<template>
  <div class="alternative-select">
    <ElSelect
      v-bind="$attrs"
      :value="value"
      class="show-for-medium"
      v-on="elSelectInputListeners"
    >
      <ElOption
        v-for="item in items"
        :key="getItemKey(item)"
        :label="getItemLabel(item)"
        :value="getItemValue(item)"
      />
    </ElSelect>

    <select
      v-bind="$attrs"
      :value="value"
      class="alternative-select__native hide-for-medium"
      v-on="selectInputListeners"
    >
      <option
        v-for="item in items"
        :key="getItemKey(item)"
        :value="getItemValue(item)"
      >
        {{ getItemLabel(item) }}
      </option>
    </select>

    <div v-if="loading" class="alternative-select__loading">
      <HollowDotsSpinner
        :animation-duration="1000"
        :dot-size="12"
        :dots-num="3"
        :color="'#95a5a6'"
      />
    </div>
  </div>
</template>

<script>
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';
export default {
  name: 'AlternativeSelect',
  components: { HollowDotsSpinner },
  inheritAttrs: false,

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    keyProp: {
      type: [String, Function],
      default: 'key',
    },
    labelProp: {
      type: [String, Function],
      default: 'label',
    },
    valueProp: {
      type: [String, Function],
      default: 'value',
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      // It can have any type
      required: true,
    },
  },
  computed: {
    selectInputListeners() {
      return {
        ...this.$listeners,
        change: event => {
          this.$emit(
            'change',
            this.items[event.target.selectedIndex][this.valueProp],
          );
        },
        input: event => {
          this.$emit(
            'input',
            this.items[event.target.selectedIndex][this.valueProp],
          );
        },
      };
    },
    elSelectInputListeners() {
      return {
        ...this.$listeners,
        input: value => this.$emit('input', value),
        change: value => this.$emit('change', value),
      };
    },
  },
  methods: {
    getItemKey(item) {
      if (typeof this.keyProp === 'function') return this.keyProp(item);
      return item[this.keyProp];
    },
    getItemLabel(item) {
      if (typeof this.labelProp === 'function') return this.labelProp(item);
      return item[this.labelProp];
    },
    getItemValue(item) {
      if (typeof this.valueProp === 'function') return this.valueProp(item);
      return item[this.valueProp];
    },
  },
};
</script>

<style lang="scss" scoped>
.alternative-select {
  position: relative;

  &__loading {
    position: absolute;
    height: 100%;
    background-color: rgba(#fff, 0.8);
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__native {
    border: $--input-border;
    border-radius: $--input-border-radius;
    color: $--color-text-regular;
    padding: 0 $global-padding;
    height: $--input-height;

    &:focus {
      border-color: $--input-focus-border;
    }
  }
}
</style>
